import {doLogout} from '../auth';

import {closeSidebar, isSidebarOpened$, openSidebar} from './index';

isSidebarOpened$.on(openSidebar, () => true).reset(closeSidebar, doLogout);
